import { useQuery } from '@tanstack/react-query'
import { PromoCodeItem } from 'Modules'

import { AppAdmin } from 'api/app-admin'
import { mapApiToPromoCodeItem } from 'modules/promo-code/api-adapters'
import { logError } from 'utils/logger'

import { promoCodeKeys } from './query-keys'

const fetchPromoCodeDetail = async (id: string): Promise<PromoCodeItem | null> => {
  try {
    const res = await AppAdmin.getPromoCodeDetail(id)
    return res.data?.data ? mapApiToPromoCodeItem(res.data.data) : null
  } catch (error) {
    logError('Error fetching promo code detail:', error)
    return null
  }
}

/** Full promo code detail (GET /admin/platform-promo-codes/:id) for View/Edit prefill. */
export const usePromoCodeDetail = (id: string | undefined) => {
  const query = useQuery({
    queryKey: promoCodeKeys.detail(id),
    queryFn: () => fetchPromoCodeDetail(id!),
    enabled: !!id,
    gcTime: 30000,
  })

  return {
    detail: query.data ?? null,
    isLoading: query.isLoading,
  }
}
